import { BaseStore, getOrCreateStore } from '../../di'
import { observable, action } from 'mobx'
import window from 'global/window'

class AuthStore extends BaseStore {
  @observable isResetPassword = false
  @observable resetPasswordErrors = null

  @action
  clearErrors = () => {
    this.resetPasswordErrors = null
  }

  @action
  setEmailValue = (value) => {
    this.email = value
  }

  @action
  clearResetPasswordWorkflow = () => {
    this.isResetPassword = false
    this.resetPasswordErrors = null
    this.resetPasswordSuccess = false
    this.resetPasswordToken = ''
  }

  fetchHubSignInWorkflow = async (email, hub, isResetPassword = false) => {
    try {
      const resp = await this.request({
        method: 'POST',
        path: `/hubs/${hub.id}/users/lookup`,
        data: { email },
      })
      if (resp.data.redirect_url && resp.data.redirect_url !== '') {
        if (isResetPassword) {
          window.location = `${resp.data.redirect_url}&resetPasswordForm=true`
          return resp.data
        } else {
          window.location = resp.data.redirect_url
          return resp.data
        }
      } else {
        return resp.data
      }
    } catch (e) {
      // need to solve the issue with connecting stores together ( authStore <=> authcommands )
      // console.error(e)
      //show(this.LocaleStore.formatMessage(messages.authLoginFailed), DANGER)
    }
  }

  requestResetPassword = async (email, hub, signInContext) => {
    const path = `/hubs/${hub.id}/password_reset_intent`
    const resp = await this.request({
      method: 'POST',
      path,
      data: { email },
    })
    return resp
  }
}

export default getOrCreateStore('AuthStore', AuthStore)
